module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.1c450711.jpg";